import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TabItem } from 'src/app/components/form-group/form-group.types';
import { FormComponent } from 'src/app/components/form-group/tab-item/form/form.component';

@Component({
    selector: 'app-tab-item',
    imports: [
        FormComponent
    ],
    templateUrl: './tab-item.component.html',
    styleUrl: './tab-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabItemComponent {
  readonly item = input.required<TabItem>();
  readonly element = input.required<Record<string, string>>();
  readonly prefixKey = input<string>('');

  readonly key = computed(() => {
    const prefix = this.prefixKey() ? `${this.prefixKey()}.` : '';
    return prefix + this.item().key;
  });
}
